<template>
  <div class="single-product swiper-slide">
    <b-link :to="`/${product.url_key}`">
      <img class="product-img img-fluid border border-secondary" :src="productImg" alt="" width="200" height="167">
    </b-link>
    <h4 class="single-product-name h5">
      <b-link :to="`/${product.url_key}`">
        {{ product.name }}
      </b-link>
    </h4>
    <div class="single-product-meta">
      <span class="d-block in-stock text-success mb-3" v-if="productInStock">{{ $t("In Stock") }}</span>
      <span class="d-block in-stock text-danger mb-3"  v-if="!productInStock">{{ $t("Out of Stock") }}</span>
      <div class="row row-cols-2 justify-content-between align-items-end">
        <div
          class="price"
          v-if="
            product.price_range.minimum_price.final_price.value ==
            product.price_range.maximum_price.final_price.value
          "
        >
          <s
            v-if="
              product.price_range.minimum_price.regular_price.value >
              product.price_range.minimum_price.final_price.value
            "
          >
            {{
              formatCurrency(
                product.price_range.minimum_price.regular_price.value
              )
            }}
          </s>
          <span class="d-block selling-price">
            {{
              formatCurrency(
                product.price_range.minimum_price.final_price.value
              )
            }}
          </span>
        </div>
        <div
          class="price"
          v-if="
            product.price_range.minimum_price.final_price.value !=
            product.price_range.maximum_price.final_price.value
          "
        >
          <span class="d-block selling-price">
            {{
              formatCurrency(
                product.price_range.minimum_price.final_price.value
              )
            }}
            -
            {{
              formatCurrency(
                product.price_range.maximum_price.final_price.value
              )
            }}
          </span>
        </div>
        <div class="d-inline-flex">
          <a
            class="add-to-cart btn btn-secondary btn-xl"
            v-if="productInStock"
            @click="addToCart"
            key="cart-btn"
          >
            <ClientOnly><i class="fa-solid fa-basket-shopping"></i></ClientOnly>
          </a>
        </div>
      </div>
    </div>
    <div class="single-product-tag-right">
      <span class="badge text-bg-secondary" v-if="onSale == true">{{ $t("offer") }}</span>
      <span class="badge text-bg-primary" v-if="onNew == true">{{ $t("new") }}</span>
    </div>
  </div>
</template>

<script>

import loaderImg from "@/base/coreassets/loader.gif";
import loaderErrorImg from "@/base/coreassets/loadererror.gif";
import { mapGetters, mapActions } from "vuex";
import getImageUrl from "@/esf_antarctica_lederhosenland/helpers/getImageUrl";
import Swiper from 'swiper';
import SwiperCore, { Navigation, Pagination } from 'swiper/core';
SwiperCore.use([Navigation, Pagination]);
import ClientOnly from "vue-client-only";

export default {
  name: "ProductCardWithPagination",
  props: {
    product: {
      type: Object,
      require: true,
    },
    viewType: {
      type: String,
      default: "grid-view",
      require: false,
    },
  },
  created() {},
  data() {
    return {
      loaderImg: loaderImg,
      loaderErrorImg: loaderErrorImg,
      isCompateChecked: true,
      showNotifyModal: false,
      wishlist_add_swiper_options: {
        breakpoints: {
          992: {
            slidesPerView: 3,
            spaceBetween: 60
          },
          1200: {
            slidesPerView: 4,
            spaceBetween: 40
          },
          1400: {
            slidesPerView: 4,
            spaceBetween: 80
          }
        },
        speed: 400,
        navigation: {
          nextEl: '.wishlist-add-swiper-button-next',
          prevEl: '.wishlist-add-swiper-button-prev',
        },
      },
      wishlist_add_swiper: false,
      offers_add_swiper_options: {
        breakpoints: {
          992: {
            slidesPerView: 3,
            spaceBetween: 60
          },
          1200: {
            slidesPerView: 4,
            spaceBetween: 40
          },
          1400: {
            slidesPerView: 4,
            spaceBetween: 80
          }
        },
        speed: 400,
        navigation: {
          nextEl: '.offers-swiper-button-next',
          prevEl: '.offers-swiper-button-prev',
        }
      },
      offers_add_swiper: false
    };
  },
  components: {
    ClientOnly
  },
  mounted() {
    this.init_slider();
    window.addEventListener('resize', this.handleWindowSizeChange);
  },
  computed: {
    ...mapGetters({
      compareList: "compare/getProductCompare",
      cartItems: "cart/getCartItems",
    }),
    productBrand() {
      let productBrand = "";
      if (this.product.information_attributes) {
        const brand = this.product.information_attributes.find(
          (item) => item.attribute_code == "merk"
        );
        if (brand) {
          productBrand = brand.value;
        }
      }
      return productBrand;
    },
    productModel() {
      let productModel = "";
      if (this.product.information_attributes) {
        const model = this.product.information_attributes.find(
          (item) => item.attribute_code == "model_number"
        );
        if (model) {
          productModel = model.value;
        }
      }
      return productModel;
    },

    onSale() {
      /*
      const today = new Date();
      if (this.product.special_from_date != null) {
        if (new Date(this.product.special_from_date) <= today) {
          if (new Date(this.product.special_to_date) >= today) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } else {
        return false;
      }
      */
      return this.product.sale;
    },
    //
    onNew() {
      /*
      const today = new Date();
      if (this.product.new_from_date != null) {
        if (new Date(this.product.new_from_date) <= today) {
          if (this.product.new_to_date != null) {
            if (new Date(this.product.new_to_date) >= today) {
              return true;
            } else {
              return false;
            }
          } else {
            return true;
          }
        } else {
          return false;
        }
      } else {
        return false;
      }
      */
      return this.product.new;
    },
    stockStatusClass() {
      return this.product.stock_status == "IN_STOCK" ? "in-stock" : "out-stock";
    },

    productImg() {
      if (this.product.thumbnail.medium) {
        return this.product.thumbnail.medium;
      }
      return this.product.thumbnail.url;
    },
    isProductInCompare() {
      if (this.compareList) {
        return !!this.compareList.find(
          (product) => product.sku === this.product.sku
        );
      } else {
        return false;
      }
    },
    productInStock() {
      return this.product.stock_status == "IN_STOCK" ? true : false;
    },
    isBackOrderAvailable() {
      return this.product.backorders_allowed;
    },
    isLoggedIn() {
      return this.$store.getters["user/getIsLoggedIn"];
    },
    finalPrice() {
      if (this.product.__typename == "ConfigurableProduct") {
        if (this.$store.getters["product/getCurrentChildSku"] != null) {
          const found = this.productConfig.variants.find((v) => {
            if (
              v.product.sku == this.$store.getters["product/getCurrentChildSku"]
            ) {
              return true;
            }
          });
          if (found != null) {
            return found.product.price_range.minimum_price.final_price.value.toFixed(
              2
            );
          }
        }
        if (
          this.product.price_range.minimum_price.final_price.value !=
          this.product.price_range.maximum_price.final_price.value
        ) {
          return (
            this.product.price_range.minimum_price.final_price.value.toFixed(
              2
            ) +
            " - " +
            this.product.price_range.maximum_price.final_price.value
              .toFixed(2)
              .replace(".", ",")
          );
        }
        return this.product.price_range.minimum_price.final_price.value.toFixed(
          2
        );
      }
      if (
        this.product.price_range.minimum_price.final_price.value !=
        this.product.price_range.maximum_price.final_price.value
      ) {
        return (
          this.product.price_range.minimum_price.final_price.value
            .toFixed(2)
            .replace(".", ",") +
          " - " +
          this.product.price_range.maximum_price.final_price.value
            .toFixed(2)
            .replace(".", ",")
        );
      }
      return this.product.price_range.minimum_price.final_price.value.toFixed(
        2
      );
    },
    regularPrice() {
      if (this.product.__typename == "ConfigurableProduct") {
        if (this.$store.getters["product/getCurrentChildSku"] != null) {
          const found = this.productConfig.variants.find((v) => {
            if (
              v.product.sku == this.$store.getters["product/getCurrentChildSku"]
            ) {
              return true;
            }
          });
          if (found != null) {
            return found.product.price_range.minimum_price.regular_price.value.toFixed(
              2
            );
          }
        }
        if (
          this.product.price_range.minimum_price.regular_price.value !=
          this.product.price_range.maximum_price.regular_price.value
        ) {
          return (
            this.product.price_range.minimum_price.regular_price.value.toFixed(
              2
            ) +
            " - " +
            this.product.price_range.maximum_price.regular_price.value
              .toFixed(2)
              .replace(".", ",")
          );
        }
        return this.product.price_range.minimum_price.regular_price.value.toFixed(
          2
        );
      }
      if (
        this.product.price_range.minimum_price.regular_price.value !=
        this.product.price_range.maximum_price.regular_price.value
      ) {
        return (
          this.product.price_range.minimum_price.regular_price.value
            .toFixed(2)
            .replace(".", ",") +
          " - " +
          this.product.price_range.maximum_price.regular_price.value
            .toFixed(2)
            .replace(".", ",")
        );
      }
      return this.product.price_range.minimum_price.regular_price.value.toFixed(
        2
      );
    },
  },
  methods: {
    async onClickCompareCheckBox() {
      if (this.isProductInCompare == false) {
        await this.$store.dispatch("compare/addCompareProduct", {
          sku: this.product.sku,
        });
      } else {
        await this.$store.dispatch("compare/removeCompareProduct", {
          sku: this.product.sku,
        });
      }
    },
    formatCurrency(value) {
      var formatter = new Intl.NumberFormat("nl-NL", {
        style: "currency",
        currency: "EUR",
      });
      return formatter.format(value);
    },
   
    closeNotifyModal() {
      this.showNotifyModal = false;
    },
    ...mapActions({
      updateToggleInCompareList: "compare/updateToggleInCompareList",
    }),

    isProductInCompareList(id) {
      if (this.getCompareProductList) {
        return this.getCompareProductList.findIndex((el) => el === id) !== -1;
      } else {
        return false;
      }
    },

    addToNotify() {
      this.showNotifyModal = true;
    },
    getGTMItems() {
      let items = {
        item_name: this.product.name,
        item_id: this.product.sku,
        quantity: this.quantity,
        price: this.finalPrice,
      };
      if (this.finalPrice != this.regularPrice) {
        items["discount"] = this.regularPrice - this.finalPrice;
      }
      return items;
    },
    async addToCart() {
      if (
        this.product.__typename == "SimpleProduct" &&
        !this.isBackOrderAvailable
      ) {
        if (typeof this.product.stock_qty != "undefined") {
          let quantity = 1;
          const existingProduct = this.cartItems.find(
            (item) => this.product.sku == item.product.sku
          );
          if (existingProduct) {
            quantity += existingProduct.quantity;
          }
          if (quantity > this.product.stock_qty) {
            const msg = {
              type: "danger",
              title: this.$t("shopping_basket"),
              text: this.$t("product_not_in_stock_msg", {
                numberOf: this.product.stock_qty,
              }),
            };
            this.$store.dispatch("messages/sendMessage", { message: msg });
            return;
          }
        }
      }

      switch (this.product.__typename) {
        case "SimpleProduct": {
          const item =
            '{data: {sku: "' + this.product.sku + '", quantity:' + 1 + "}}  ";
          let retval = await this.$store.dispatch("cart/addToCart", {
            type: this.product.__typename,
            item: item,
          });
          if (retval == false) {
            const msg = {
              type: "danger",
              title: this.$t("shopping_basket"),
              text: this.$t("not_add_product"),
            };
            this.$store.dispatch("messages/sendMessage", { message: msg });
          } else {
            const msg = {
              type: "success",
              title: this.$t("shopping_basket"),
              text: this.$t("added_product"),
            };
            if (this.$gtm.enabled()) {
              if (!this.$gtm.uaDisabled) {
                window.dataLayer.push({
                  event: "eec.add",
                  ecommerce: {
                    add: {
                      products: [
                        {
                          name: this.product.name,
                          id: this.product.sku,
                          quantity: this.quantity,
                        },
                      ],
                    },
                  },
                });
              }
              if (this.$gtm.ga4Enabled) {
                window.dataLayer.push({
                  event: "add_to_cart",
                  ecommerce: {
                    add: {
                      currency: "EUR",
                      value: this.finalPrice,
                      items: [this.getGTMItems()],
                    },
                  },
                });
              }
            }
            this.$store.dispatch("messages/sendMessage", { message: msg });
            // this.$bvModal.show("modal-1");
          }
          break;
        }
        case "ConfigurableProduct":
        case "BundleProduct":
        case "GroupedProduct": {
          this.$router.push(`/${this.product.url_key}`);
          break;
        }

        default:
          break;
      }
    },
    toggleWishItem() {
      if (this.$store.getters["user/getIsLoggedIn"] == true) {
        if (
          this.$store.getters["user/isProductInWishlist"](this.product.sku) ==
          true
        ) {
          this.$store.dispatch("user/setProductWishlistStatus", {
            sku: this.product.sku,
            parentSku: null,
          });
        } else {
          if (this.product.__typename == "SimpleProduct") {
            this.$store.dispatch("user/setProductWishlistStatus", {
              sku: this.product.sku,
              parentSku: null,
            });
          } else {
            const msg = {
              type: "danger",
              title: this.$t("wishlist error"),
              text: this.$t("wishlist_select_options"),
            };
            this.$store.dispatch("messages/sendMessage", { message: msg });
            this.$router.push("/" + this.product.url_key);
          }
        }
      } else {
        const msg = {
          type: "danger",
          title: this.$t("wishlist error"),
          text: this.$t("wishlist_logged_in"),
        };
        this.$store.dispatch("messages/sendMessage", { message: msg });
      }
    },
    imgUrl(filename) {
      return getImageUrl(filename);
    },
    init_slider() {
      if(window.innerWidth >= 992) {
        if( !this.offers_add_swiper ) {
          if(document && document.querySelector('.offers .product-grid') && document.querySelector('.offers .product-grid').classList){
            document.querySelector('.offers .product-grid').classList.add('product-grid-carousel')
          }
          if(document && document.querySelector('.offers .swiper > .row') && document.querySelector('.offers .swiper > .row').classList){
            document.querySelector('.offers .swiper > .row').classList.add('swiper-wrapper')
          }
          document.querySelectorAll('.offers .swiper > .row > div').forEach(function (ele) {
            if(ele && ele.classList){
              ele.classList.add('swiper-slide')
            }
          })
          this.offers_add_swiper = new Swiper('.offers .swiper', this.offers_add_swiper_options)
          if(document && document.querySelector('.swiper-button-prev.swiper-nav-round.offers-swiper-button-prev')){
            document.querySelector('.swiper-button-prev.swiper-nav-round.offers-swiper-button-prev').style.display = 'block';
          }
          if(document && document.querySelector('.swiper-button-next.swiper-nav-round.offers-swiper-button-next')){
            document.querySelector('.swiper-button-next.swiper-nav-round.offers-swiper-button-next').style.display = 'block';
          }
        }
      }else if(this.offers_add_swiper.initialized){
        this.offers_add_swiper.destroy()
        this.offers_add_swiper = false
        if(document && document.querySelector('.offers .product-grid') && document.querySelector('.offers .product-grid').classList){
          document.querySelector('.offers .product-grid').classList.remove('product-grid-carousel')
        }
        if(document && document.querySelector('.offers .swiper > .row') && document.querySelector('.offers .swiper > .row').classList){
          document.querySelector('.offers .swiper > .row').classList.remove('swiper-wrapper')
        }
        document.querySelectorAll('.offers .swiper > .row > div').forEach(function (ele) {
          if(ele && ele.classList){
            ele.classList.remove('swiper-slide')
          }
        })
        if(document && document.querySelector('.swiper-button-prev.swiper-nav-round.offers-swiper-button-prev')){
          document.querySelector('.swiper-button-prev.swiper-nav-round.offers-swiper-button-prev').style.display = 'none';
        }
        if(document && document.querySelector('.swiper-button-next.swiper-nav-round.offers-swiper-button-next')){
          document.querySelector('.swiper-button-next.swiper-nav-round.offers-swiper-button-next').style.display = 'none';
        }
      }else{
        if(document && document.querySelector('.offers .product-grid') && document.querySelector('.offers .product-grid').classList){
          document.querySelector('.offers .product-grid').classList.remove('product-grid-carousel')
        }
        if(document && document.querySelector('.offers .swiper > .row') && document.querySelector('.offers .swiper > .row').classList){
          document.querySelector('.offers .swiper > .row').classList.remove('swiper-wrapper')
        }
        document.querySelectorAll('.offers .swiper > .row > div').forEach(function (ele) {
          if(ele && ele.classList){
            ele.classList.remove('swiper-slide')
          }
        })
        if(document && document.querySelector('.swiper-button-prev.swiper-nav-round.offers-swiper-button-prev')){
          document.querySelector('.swiper-button-prev.swiper-nav-round.offers-swiper-button-prev').style.display = 'none';
        }
        if(document && document.querySelector('.swiper-button-next.swiper-nav-round.offers-swiper-button-next')){
          document.querySelector('.swiper-button-next.swiper-nav-round.offers-swiper-button-next').style.display = 'none';
        }
      }
    },
    handleWindowSizeChange() {
      this.init_slider();
    }
  },
};
</script>

<style lang="scss" scoped>
.product-card--img-top {
  width: 100%;
  //background-size: contain;
}
.add-to-wishlist {
  position: absolute;
  left: 10px;
  top: 3px;
  font-size: 21px;
  z-index: 9;
  width: 22px;
  height: 28px;
  &:hover {
    text-decoration: none;
  }
  &:hover {
    ~ .product-card {
      color: $black !important;
      box-shadow: 0 0 5px 1px rgba(0, 0, 0, 20%);
    }
  }
  .added {
    color: $red;
  }
  .not-added {
    color: $borderColor;
  }
}

.product-card {
  padding: 10px 18px;
  display: block;
  height: 100%;
  transition: 0.5s;
  color: $black !important;
  &:hover {
    box-shadow: 0 0 5px 1px rgba(0, 0, 0, 20%);
    text-decoration: none;
  }

  &--holder {
    display: block;
    position: relative;
    width: 100%;
    height: 100%;
    border: 1px solid $borderColor;
  }

  &--img-top {
    width: 100%;
    height: 200px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: 50% 50%;
    margin-bottom: 10px;
    position: relative;
  }

  &--product-name {
    font-size: 15px;
    font-weight: 600;
    line-height: 1.3;
    margin-bottom: 10px;
    height: 57px;
    color: $black;
    @include truncat-3;
  }

  &--price {
    font-size: 16px;
    font-weight: 600;
  }

  &--sale-comment {
    font-size: 13px;
    font-weight: 500;
    color: $red;
    padding-top: 5px;
  }

  .actionbuttons {
    position: absolute;
    top: -10px;
    left: auto;
    right: -20px;
    text-align: right;
    display: flex;
    flex-direction: column;
    align-items: end;

    .sale-txt,
    .new-txt {
      background: $red;
      font-weight: 500;
      color: $white;
      font-size: 12px;
      padding: 4px 8px;
      border-radius: 4px;
    }
    .sale-txt {
      position: relative;
    }
    .new-txt {
      background: $primaryColor;
    }
    @media screen and (max-width: 560px) {
      right: -10px;
    }
  }
  @media screen and (max-width: 670px) {
    padding: 10px;
    &--img-top {
      height: 150px;
    }
  }
  @media screen and (max-width: 560px) {
    &--product-name {
      height: auto;
    }
  }
}
.available-sizes-list {
  margin: 0 -0.7rem;
  flex-grow: 1;
  flex-direction: row;
  margin-bottom: 0;

  li {
    background: $green;
    color: $white;
    font-weight: 500;
    min-width: 45px;
    height: 25px;
    margin: 0.45rem 0.7rem;
    text-align: center;
    padding: 4px 5px;
    line-height: 1;
  }
}
</style>
